import { Routes } from '@angular/router';
import { Tests } from './tests';
import { DebugReferentsParc } from './debug-referents-parc/debug-referents-parc';
import { DebugChiffresUtiles } from './debug-chiffres-utiles/debug-chiffres-utiles';
import { accesAdministrateurGuard } from '../../Services/acces-installations.guard';

export const testsRoutes: Routes = [
  {
    path: 'tests',
    component: Tests,
    title: 'Tests',
    canMatch: [accesAdministrateurGuard],
    data: { hideSiloParc: true },
  },
  {
    path: 'tests/debug-referents-parc',
    component: DebugReferentsParc,
    title: 'Debug référents Parc',
    canMatch: [accesAdministrateurGuard],
    data: { hideSiloParc: true },
  },
  {
    path: 'tests/debug-chiffres-utiles',
    component: DebugChiffresUtiles,
    title: 'Debug chiffres utiles Parc',
    canMatch: [accesAdministrateurGuard],
    data: { hideSiloParc: true },
  },
];
